// src/pages/supervisors/AddSupervisorPage/FormFields.js

import React from "react";
import { Form, Input } from "antd";

const FormFields = () => {
  return (
    <>
      <Form.Item
        label="Prénom"
        name="firstName"
        rules={[{ required: true, message: "Le prénom est requis" }]}
      >
        <Input placeholder="Prénom du superviseur" />
      </Form.Item>

      <Form.Item
        label="Nom"
        name="lastName"
        rules={[{ required: true, message: "Le nom est requis" }]}
      >
        <Input placeholder="Nom du superviseur" />
      </Form.Item>

      <Form.Item
        label="Nom du Profil"
        name="name"
        rules={[{ required: true, message: "Le nom du profil est requis (ex: Superviseur Nabeul)" }]}
      >
        <Input placeholder="Ex: Superviseur Grand Tunis" />
      </Form.Item>

      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: "L'email est requis" },
          { type: 'email', message: "Veuillez entrer un email valide" }
        ]}
      >
        <Input placeholder="email@exemple.com" />
      </Form.Item>

      <Form.Item
        label="Mot de passe"
        name="password"
        rules={[
          { required: true, message: "Le mot de passe est requis" },
          { min: 6, message: 'Le mot de passe doit contenir au moins 6 caractères' }
        ]}
      >
        <Input.Password placeholder="Mot de passe" />
      </Form.Item>
    </>
  );
};

export default FormFields;